import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Dashboard from "./pages/Dashboard";
import Resources from "./pages/Resources";
import Progress from "./pages/Progress";
import ResourceArticle from "./pages/ResourceArticle";
import InterviewTips from "./pages/InterviewTips";
import InterviewTip from "./pages/InterviewTip";
import MayaHome from "./pages/MayaHome";
import MayaInterview from "./pages/MayaInterview";
import Profile from "./pages/Profile";
import Pricing from "./pages/Pricing";
import OurStory from "./pages/OurStory";
import OurGuides from "./pages/OurGuides";
import MayaLanding from "./pages/MayaLanding";
import MockMMI from "./pages/MockMMI";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import RefundCancellationPolicy from "./pages/RefundCancellationPolicy";
import { Login, Signup } from "./pages/Auth";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";
import { SidebarProvider } from "./hooks/useSidebar";
import { AuthProvider } from "./hooks/useAuth";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
      <BrowserRouter>
      <SidebarProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/dashboard/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/dashboard/interviews" element={<ProtectedRoute><InterviewTips /></ProtectedRoute>} />
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />
          <Route path="/resources/:guideSlug/:topicSlug" element={<ProtectedRoute><ResourceArticle /></ProtectedRoute>} />
          <Route path="/progress" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
          <Route path="/interview-tips/:tipSlug" element={<ProtectedRoute><InterviewTip /></ProtectedRoute>} />
          <Route path="/maya" element={<ProtectedRoute><MayaHome /></ProtectedRoute>} />
          <Route path="/maya/interview/:interviewId" element={<ProtectedRoute><MayaInterview /></ProtectedRoute>} />
          <Route path="/maya/interview/:interviewId/summary" element={<ProtectedRoute><MayaInterview /></ProtectedRoute>} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<OurStory />} />
          <Route path="/what-we-offer/guides" element={<OurGuides />} />
          <Route path="/what-we-offer/maya" element={<MayaLanding />} />
          <Route path="/what-we-offer/mock-mmi" element={<MockMMI />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/refund-cancellation-policy" element={<RefundCancellationPolicy />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <CookieBanner />
      </SidebarProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
